module.exports = __webpack_public_path__ + "static/img/logo_footer.c9d46b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_footer.svg
// module id = 8B4O
// module chunks = 1